import { render, staticRenderFns } from "./Requestdel.vue?vue&type=template&id=93c331b4&scoped=true&"
import script from "./Requestdel.vue?vue&type=script&lang=js&"
export * from "./Requestdel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c331b4",
  null
  
)

export default component.exports